
         $(document).ready(function() {
          
        
           $('.search-button-custom').click(
             function(){
               $('#search-overlay').css('display','block');
                $('#search-overlay').addClass('search-overlay-active');
               $('#clara-premium-silver-jewellery-amp-certified-gemstones, .template-collection').addClass('search-overlay-active-body');
             }
           );
           $('#closeBtnSearch').click(
             function(){
                $('#search-overlay').css('display','none');
                $('#search-overlay').removeClass('search-overlay-active');
               $('#clara-premium-silver-jewellery-amp-certified-gemstones, .template-collection').removeClass('search-overlay-active-body');
             }
           );
        

      $('#filterBy').click(
             function(){
               $('#filter-overlay').css('display','block');
                $('#filter-overlay').addClass('search-overlay-active'); 
               $('.template-collection').addClass('search-overlay-active-body');
             }
           );
           $('#closeBtnFilter, #applyBtn').click(
             function(){
                $('#filter-overlay').css('display','none');
                $('#filter-overlay').removeClass('search-overlay-active');
               $('.template-collection').removeClass('search-overlay-active-body');
               }
           );
         
        
            });
        

  
   $(document).ready(function(){
     
    $('.discount-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0557/9158/3406/files/chevron-white-right.png?v=1725963579"></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0557/9158/3406/files/chevron-white.png?v=1725963579"></button>',
   
    });
    $('.discount-slider').show();
    
    setTimeout(
      function() 
      {
        $('#rawa-greeting.rawa-greeting--opened').css('display','none');
        $('#shopify-section-product-notification').css('display','none');
      }, 5000);
    });

     $('.toggle-btn-mobile').on('click', function() {
        // Remove background color from all buttons
        $('.toggle-btn-mobile').removeClass('active');
        
        // Add background color to the currently clicked button
        $(this).addClass('active');
    });
  
  function toggleCheckboxes() {
    $('.toolbar-sect, .filter-sect, .clear_outer').addClass('filter-overlay-active');
   $('.product_arrow, .price_arrow, .color_arrow').addClass('fa-angle-down');
    $('.product_arrow, .price_arrow, .color_arrow').removeClass("fa-angle-up");
    
  if ($('.gemstone-filters').css('display') === 'block')  {
    $(".toolbar-sect, .filter-sect, .clear_outer").removeClass('filter-overlay-active');
    $(".gemstone-filters").css('display','none');
    $(".gemstone_arrow").addClass("fa-angle-down");
    $(".gemstone_arrow").removeClass("fa-angle-up");
     $(".clearBtnDesk").css('display','none');
     
  } else {
    $('.checkbox-container').css('display','none');
    $(".gemstone-filters").css('display','block');
     $(".gemstone_arrow").removeClass("fa-angle-down");
    $(".gemstone_arrow").addClass("fa-angle-up");
  
   
  }
 
  
}

  function toggleCheckboxesProductType(){
      $('.toolbar-sect, .filter-sect, .clear_outer').addClass('filter-overlay-active');
       $('.gemstone_arrow, .price_arrow, .color_arrow,.category_arrow').addClass('fa-angle-down');
    $('.gemstone_arrow, .price_arrow, .color_arrow,.category_arrow').removeClass("fa-angle-up");
  
  if ($('.productType-filters').css('display') === 'block'){
     $('.toolbar-sect, .filter-sect, .clear_outer').removeClass('filter-overlay-active');
    $(".productType-filters").css('display','none');
   $(".product_arrow").addClass("fa-angle-down");
    $(".product_arrow").removeClass("fa-angle-up");
     $(".clearBtnDesk").css('display','none');
  } else {
     $('.checkbox-container').css('display','none');
     $(".productType-filters").css('display','block');
      $(".product_arrow").removeClass("fa-angle-down");
     $(".product_arrow").addClass("fa-angle-up");
  }
 
  }

  
  function toggleCheckboxesCategoryType(){
      $('.toolbar-sect, .filter-sect, .clear_outer').addClass('filter-overlay-active');
       $('.gemstone_arrow, .price_arrow, .color_arrow,.product_arrow').addClass('fa-angle-down');
    $('.gemstone_arrow, .price_arrow, .color_arrow,.product_arrow').removeClass("fa-angle-up");
  
  if ($('.category-filters').css('display') === 'block'){
     $('.toolbar-sect, .filter-sect, .clear_outer').removeClass('filter-overlay-active');
    $(".category-filters").css('display','none');
   $(".category_arrow").addClass("fa-angle-down");
    $(".category_arrow").removeClass("fa-angle-up");
     $(".clearBtnDesk").css('display','none');
  } else {
     $('.checkbox-container').css('display','none');
     $(".category-filters").css('display','block');
      $(".category_arrow").removeClass("fa-angle-down");
     $(".category_arrow").addClass("fa-angle-up");
  }
 
  }
  
  function togglePrice(){
      $('.toolbar-sect, .filter-sect, .clear_outer').addClass('filter-overlay-active');
       $('.product_arrow, .gemstone_arrow, .color_arrow,.category_arrow').addClass('fa-angle-down');
    $('.product_arrow, .gemstone_arrow, .color_arrow,.category_arrow').removeClass("fa-angle-up");
 
  
  if ($('.price-filters').css('display') === 'block') {
     $('.toolbar-sect, .filter-sect, .clear_outer').removeClass('filter-overlay-active');
    $(".price-filters").css('display','none');
   $(".price_arrow").addClass("fa-angle-down");
    $(".price_arrow").removeClass("fa-angle-up");
     $(".clearBtnDesk").css('display','none');
  } else {
     $('.checkbox-container').css('display','none');
    $(".price-filters").css('display','block');
   $(".price_arrow").removeClass("fa-angle-down");
    $(".price_arrow").addClass("fa-angle-up");
  }
   
  }

   function toggleColor(){
       $('.toolbar-sect, .filter-sect, .clear_outer').addClass('filter-overlay-active');
        $('.product_arrow, .price_arrow, .gemstone_arrow,.category_arrow').addClass('fa-angle-down');
    $('.product_arrow, .price_arrow, .gemstone_arrow,.category_arrow').removeClass("fa-angle-up");
 
  
  if ($('.color-filters').css('display') === 'block') {
     $('.toolbar-sect, .filter-sect, .clear_outer').removeClass('filter-overlay-active');
    $(".color-filters").css('display','none');
      $(".color_arrow").addClass("fa-angle-down");
    $(".color_arrow").removeClass("fa-angle-up");
     $(".clearBtnDesk").css('display','none');
  } else {
     $('.checkbox-container').css('display','none');
    $(".color-filters").css('display','block');
      $(".color_arrow").removeClass("fa-angle-down");
    $(".color_arrow").addClass("fa-angle-up");
  }
   
  }


  
var collectionHandle = window.collectionHandle || ""; // Set inline in theme.liquid from {{ collection.handle }}

$(document).ready(function() {
  
    var url = window.location.href;

    // Split the URL by "?"
    var splitUrl = url.split('?');
//console.log(splitUrl.length);
if(splitUrl.length > 1){
    var urlAfterRings = splitUrl[0].split('/'+collectionHandle+'/')[1];
 //console.log(urlAfterRings);
   if(urlAfterRings){
    var valuesArray = urlAfterRings.split('+');
     //console.log(valuesArray);
    // console.log(splitUrl.length);
    if (valuesArray) {
       $('.clearBtn').show();
    }else{
      $('.clearBtn').hide();
    }
   }else{
     //console.log(splitUrl[1]);
     if (splitUrl[1]) {
       $('.clearBtn').show();
    }else{
      $('.clearBtn').hide();
    }
   }
   }else{
      var urlParts = url.split('/');
   //console.log(urlParts); 
    if (urlParts.length > 5) {
        var fourthPart = urlParts[5]; 
      if(fourthPart){
        var valuesArray = fourthPart.split('+');
      //console.log(valuesArray);
       if (valuesArray ) {
       $('.clearBtn').show();
    }else{
      $('.clearBtn').hide();
    }
      }
    }
   }
   if(valuesArray){
     valuesArray.forEach(function(tag) {
            $('.filter-checkbox[value="' + tag + '"]').prop('checked', true);
        });
   }
     
     var width = $(window).width();
          if (width <= 820) {
        $('.filter-outer-mobile .filter-checkbox:checked').each(function() {
            let tagText = $(this).val(); // Get the value of the checkbox
            //console.log(tagText);
            let tagVal = $(this).parent().text();
            //console.log(tagVal);
            $('#productTags').append('<span id='+tagText+' class="tag-item"><span class="remove-tag" style="cursor:pointer;color:red;">&times;</span>' + tagVal + 
            ' </span>  ');
        });
          }else{
             $('.filter-outer-desk .filter-checkbox:checked').each(function() {
            let tagText = $(this).val(); // Get the value of the checkbox
            //console.log(tagText);
            let tagVal = $(this).parent().text();
            //console.log(tagVal);
            $('#productTags').append('<span id='+tagText+' class="tag-item"><span class="remove-tag" style="cursor:pointer;color:red;">&times;</span>' + tagVal + 
            ' </span>  ');
        });
          }
  
});

           $('#productTags').on('click', '.remove-tag', function() {
               let tagText = $(this).parent().attr('id').trim();   
            $('.filter-checkbox[value="' + tagText + '"]').prop('checked', false).trigger('change');     
          console.log("tagText:", tagText);
        var url = window.location.href;
  // Extract the portion after '/collections/rings/'
    var afterCollection = url.split('/collections/'+collectionHandle+'/')[1];
             console.log("afterCollection"+afterCollection);


// Check if 'afterCollection' is not empty
if (afterCollection) {
   // Split into parts based on '?' to separate the query parameters
    var mainFilters = afterCollection.split('?')[0]; // "gemstone-zircon+price-2000-3000"
    var queryParams = afterCollection.split('?')[1]; // "sort_by=price-descending"

    // Split the mainFilters into an array using '+'
    var filterArray = mainFilters.split('+'); // ["gemstone-zircon", "price-2000-3000"]

    // Remove the item "price-2000-3000" from filterArray
    filterArray = filterArray.filter(function(item) {
        return item !== tagText;
    });
   const filterString = filterArray.join('+');
     console.log("filterString"+filterString);
             if(queryParams){
               var newUrl = window.location.protocol + '//' + window.location.host + '/collections/' + collectionHandle +"/"+ filterString + "?" + queryParams ;
             }
             else{
                var newUrl = window.location.protocol + '//' + window.location.host + '/collections/' + collectionHandle +"/"+ filterString ;
             
             }
       //console.log("@@@@@@@"+newUrl);
} else {
        var newUrl = window.location.protocol + '//' + window.location.host + '/collections/' + collectionHandle ;
 // console.log("#########"+newUrl);
}
        window.location.href = newUrl;
        });
  
  

        // Clear all checkboxes when the button is clicked
        $('.clearBtn').click(function() {
            //$('.gemstone-checkbox').prop('checked', false);
            //toggleClearButton(); // Hide the button after clearing
          var newUrl = window.location.protocol + '//' + window.location.host + '/collections/' + collectionHandle;
          window.location.href = newUrl;
        });

  //let infiniteScrollingEnabled = true;

$(document).ready(function() {
    var stickyDiv = $('.toolbar-mobile');

    $(window).on('scroll', function() {
        if ($(window).scrollTop() >= 200) {
            var topValue = $(window).width() < 350 ? '50px' : '60px';

            stickyDiv.css({
                'position': 'fixed',
                'top': topValue,
                'z-index': '999',
                'width': '100%',
                'background': 'rgb(255, 255, 255)'
            });
        } else {
            stickyDiv.css('position', 'static');
        }
    });
});

  


  // Optimized Currency Replacer (No Heavy Continuous Intervals)
  function fixCurrencySymbols() {
    var selectors = '.price-box .sale span, .template-product .price-compare-outer span, .template-product .total-price span, #wish-list .price-box, .template-cart .price, .total .price, .cart-collateral .price';
    document.querySelectorAll(selectors).forEach(function(el) {
      if (el.innerHTML.includes('Rs.') || el.innerHTML.includes('$')) {
        el.innerHTML = el.innerHTML.replace(/Rs\.|\$/g, '₹');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    fixCurrencySymbols();
    
    // YMQ Ring Size Guide App Enhancements
    setTimeout(function() {
      if ($('[data-label="Size"]').length) {
        $('.ymq-option-title').filter(function() {
          return $(this).closest('[data-label="Size"]').length;
        }).append(`
          <div class="ring_size_outer" data-ymq-id="ymqdialogbox1tem1" data-handle="">
            <img width="20" height="18" src="https://cdn.shopify.com/s/files/1/0762/6696/3225/files/wedding-rings.png?v=1706676565" alt="Ring Size">
            <span>Ring Size Guide</span>
          </div>
        `);
        $('.ymq-options-box[data-label="Size"] .ymq-option-title .ymq_lable').text('Select Ring Size');
        $(".ymq-option-powered-by").hide();
        
        $(".ring_size_outer").on('click', function(){
          $('body').addClass("stop_scroll");
        });
      }
    }, 1200);

    // Mobile Ribbon Widget Relocation
    if ($(window).width() <= 600) {
      setTimeout(function() {
        var existingDiv = $('#ribbon_widget');
        if (existingDiv.length) {
          $('#add-to-cart-form').append(existingDiv);
        }
      }, 1200);

      // Mobile Accordion Tabs
      var $tabLink = $('#myTab li a');
      var $tabContent = $('#collapse-tab1');
      $tabLink.addClass('active minus-icon');
      $tabContent.addClass('active show');

      $tabLink.on('click', function(e) {
        e.preventDefault();
        $tabContent.toggleClass('active show');
        $(this).toggleClass('minus-icon');
      });
    }

    // Modal & Share Controls
    $('.close-ymq-modal').on('click', function() {
      $('#ymqdialogbox1tem1').css({
        'opacity': '1',
        'visibility': 'hidden',
        'top': '150px',
        'width': '700px',
        'margin-left': '-350px'
      });
      $('body').removeClass("stop_scroll");
    });

    $('.share-button__button').on('click', function(e) {
      e.preventDefault();
      $('#social-share-popup').fadeIn();
      $('body').css('overflow', 'hidden'); 
    });

    $('#close-popup-share').on('click', function() {
      $('#social-share-popup').fadeOut();
      $('body').css('overflow', ''); 
    });

    // Product Recommendations Placement
    if ($('body').hasClass('template-product')) {
      $('#product-recommendations').insertAfter('#shopify-section-hompage-testimonials');
    }

    $('.shopify-payment-button__button').text('Buy Now');

    // Zoom trigger
    $('.product-zoom-box').on('click', function() {
      var activeSlide = $('.product-photo-container .slick-active a');
      if (activeSlide.length) {
        activeSlide.trigger('click');
      }
    });

    // Menu Hover Triggers
    $(document).on('mouseover', '.natural_gemstones ul li.tmenu_item_level_1', function () {
      $(this).addClass('show-submenu');
    }).on('mouseout', '.natural_gemstones ul li.tmenu_item_level_1', function () {
      $(this).removeClass('show-submenu');
    });

    $(document).on('mouseover', '.premium_gemstones ul li.tmenu_col-1', function () {
      $(this).addClass('show-submenu');
    }).on('mouseout', '.premium_gemstones ul li.tmenu_col-1', function () {
      $(this).removeClass('show-submenu');
    });

    // Gift Box Checkbox Customization
    setTimeout(function() {
      $('#button_modal-save').on('click', function () {
        $("#giftItToggle > svg, #giftItToggle input").remove();
        $("#giftItToggle").prepend("<input type='checkbox' checked>");
        $("#giftItToggle").css("pointer-events","none");
      });
    }, 1200);

    // Collection Filter Execution (Only runs if collectionHandle exists)
    document.querySelectorAll('.filter-checkbox').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        if (typeof collectionHandle === 'undefined' || !collectionHandle) return;

        const selectedFilters = Array.from(document.querySelectorAll('.filter-checkbox:checked')).map(cb => cb.value);
        const uniqueFilters = [...new Set(selectedFilters)];
        var final_Fil = uniqueFilters.join('+');
        var url = window.location.href;

        if (url.includes('/collections/' + collectionHandle + '/')) {
          var afterCollection = url.split('/collections/' + collectionHandle + '/')[1];
          if (afterCollection) {
            var queryParams = afterCollection.split('?')[1];
            if (afterCollection.toLowerCase().includes("ratti")) {
              uniqueFilters.push(afterCollection);
            }
            var newStringFil = uniqueFilters.join('+');
            var newUrl = window.location.protocol + '//' + window.location.host + '/collections/' + collectionHandle + "/" + newStringFil + (queryParams ? "?" + queryParams : "");
          } else {
            var newUrl = window.location.protocol + '//' + window.location.host + '/collections/' + collectionHandle + "/" + final_Fil;
          }
        } else {
          var newUrl = window.location.protocol + '//' + window.location.host + '/collections/' + collectionHandle + "/" + final_Fil;
        }
        window.location.href = newUrl;
      });
    });
  });
